import { EReportPeriod } from '@westondev/tableturn-core';
import { ParseKeys } from 'i18next';

export type SomePeriods =
  | EReportPeriod.TODAY
  | EReportPeriod.YESTERDAY
  | EReportPeriod.THIS_WEEK
  | EReportPeriod.THIS_MONTH
  | EReportPeriod.THIS_YEAR
  | EReportPeriod.CUSTOM;

export const TIME_PERIOD_TEXT: Record<SomePeriods, ParseKeys> = {
  [EReportPeriod.TODAY]:
    'managementModule.employeesScreen.topBar.timePeriod.today',
  [EReportPeriod.YESTERDAY]:
    'managementModule.employeesScreen.topBar.timePeriod.yesterday',
  [EReportPeriod.THIS_WEEK]:
    'managementModule.employeesScreen.topBar.timePeriod.week',
  [EReportPeriod.THIS_MONTH]:
    'managementModule.employeesScreen.topBar.timePeriod.month',
  [EReportPeriod.THIS_YEAR]:
    'managementModule.employeesScreen.topBar.timePeriod.year',
  [EReportPeriod.CUSTOM]:
    'managementModule.employeesScreen.topBar.timePeriod.custom.button',
};
